// Chronological activity feed backing the 🔔 bell panel (ui/eventLogPanel.js).
// A pure state mutation, same layering as the rest of systems/ — the UI
// module only ever reads state.eventLog and calls logEvent() to add to it.

// Toasts (ui/toast.js) vanish after ~2s by design — useful in the moment,
// gone the second you look away. This is the same events, kept around so
// a player can check "what just happened" after the fact. Capped rather
// than unbounded: a whole session's worth of every correct/wrong answer
// would grow forever otherwise, for a panel that only ever shows the
// recent past, not a full history export.
export const EVENT_LOG_MAX = 50;

export const EVENT_TYPES = {
  correct: { icon: "✅", label: "Correct" },
  wrong: { icon: "❌", label: "Wrong" },
  extinction: { icon: "💀", label: "Extinction" },
  badge: { icon: "🏆", label: "Achievement" },
  levelup: { icon: "🎉", label: "Level Up" },
  system: { icon: "ℹ️", label: "System" }
};

/** Adds a new entry at the front (most recent first — the panel renders
 * state.eventLog in array order with no further sorting), trimming the
 * oldest entries past EVENT_LOG_MAX. */
export function logEvent(state, type, message) {
  state.eventLog.unshift({ type, message, timestamp: Date.now() });
  if (state.eventLog.length > EVENT_LOG_MAX) {
    state.eventLog.length = EVENT_LOG_MAX;
  }
}
